class MyDeliverySaverController {
    constructor($state, $scope, myDeliverySaverService, deliverySaverConstants, settings) {
        this.$state = $state;
        this.$scope = $scope;
        this.myDeliverySaverService = myDeliverySaverService;
        this.deliverySaverConstants = deliverySaverConstants;
        this.settings = settings;
    }

    $onInit() {
        this.isLoading = true;

        this.myDeliverySaverService.initalize()
            .then(() => {
                this.isLoading = false;
                if (this.myDeliverySaverService.subscription) {
                    this.cardExpiryReminderNotificationText = this.settings.deliverySaver.cardExpiryReminderNotificationText
                        .replace('{{ CardSuffix }}', this.myDeliverySaverService.subscription.CardSuffix);
                }
            })
            .catch(() => {
                this.$state.go('shop.deliveryplus', null, { location: 'replace' });
            });

        this.$scope.$on(this.deliverySaverConstants.PANEL_EXPANDED_EMIT_EVENT, (event, scopeId) => this.onChildPanelExpanded(event, scopeId));
        this.myCancelledSubscriptionNotificationMessage = this.settings.deliverySaver.myCancelledSubscriptionNotificationMessage.replace('{{ DiscoverPageUrl }}', this.settings.deliverySaver.discoverPageUrl);
    }

    /**
     * To build accordion functionality,
     * catch panelExpanded events from child scopes
     * and broadcast a panelExpanded event to their siblings
     * so that we can avoid using $rootScope
     * @param {*} event
     * @param {number} scopeId The scope ID of the panel that expanded
     */
    onChildPanelExpanded(event, scopeId) {
        event.stopPropagation();
        this.$scope.$broadcast(this.deliverySaverConstants.PANEL_EXPANDED_BROADCAST_EVENT, scopeId);
    }

    onMessageClicked(event) {
        const sectionHref = event.target.getAttribute('section-href');
        if (!sectionHref) return;

        const panel = document.querySelector(`wow-my-delivery-saver-panel[section="'${sectionHref}'"]`);
        if (!panel) return;

        this.$scope.$broadcast(this.deliverySaverConstants.PANEL_EXPAND, sectionHref);
        panel.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    }
}

MyDeliverySaverController.$inject = ['$state', '$scope', 'MyDeliverySaverService', 'DeliverySaverConstants', 'Settings'];

const MyDeliverySaverComponentDefinition = {
    controller: MyDeliverySaverController,
    template: require('./my-delivery-saver.component.html').trim(),
};

module.exports = {
    MyDeliverySaverController,
    MyDeliverySaverComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/deliverysaver/mydeliverysaver/mydeliverysaver/my-delivery-saver.component.js